import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function requireOne(control: UntypedFormGroup): ValidationErrors | null {
  // if it's not a group, ignore and return valid
  if (!control.controls) {
    return null;
  }

  const hasError = Object.keys(control.controls)
    .some(key => control.controls[key].value) === false;

  return hasError ? {requireOne: true} : null;
}
